import type { CinematicMomentKind } from "@/lib/cinematic/cinematicMomentsEngine";

/**
 * Sponsor Moment Activations
 * Registry mapping cinematic kinds → sponsor presenters.
 * Brand names removed (no contracts in place). Defaults to "Patrocinio Disponible"
 * with VerseSport intelligence tagline. The slot is read from `sponsor_config`
 * in Supabase by the renderer when needed; this module returns the safe fallback.
 */
export type SponsorPresenter = {
  brand: string;
  hex: string;
  tagline?: string;
};

const FALLBACK: SponsorPresenter = {
  brand: "Patrocinio Disponible",
  hex: "#E94560",
  tagline: "Powered by VerseSport Intelligence",
};

const REGISTRY: Partial<Record<CinematicMomentKind, SponsorPresenter>> = {
  last_minute_drama: FALLBACK,
  nation_dominance: FALLBACK,
  community_shockwave: FALLBACK,
  rivalry_surge: FALLBACK,
  prediction_explosion: FALLBACK,
};

let enabled = true;
export function setSponsorMomentsEnabled(v: boolean) { enabled = v; }

export function sponsorFor(kind: CinematicMomentKind): SponsorPresenter | null {
  if (!enabled) return null;
  return REGISTRY[kind] ?? null;
}
